import { List } from "immutable";
import { handleActions } from "redux-actions";
import { COLLECTIONS } from "constants/action-types";

interface IState {
    allCollectionsFetched: boolean;
    error?: boolean;
    isCreating?: boolean;
    isCopying?: boolean;
    isFetching: boolean;
    results: List<any>;
}

const initialState: IState = {
    allCollectionsFetched: false, // TODO: Is this necessary to prevent more calls to server?
    error: undefined,
    isCreating: false,
    isCopying: false,
    isFetching: false,
    results: undefined,
};

export const collections = handleActions(
    {
        [COLLECTIONS.COLLECTION.CREATE.START]: (state: IState): IState => {
            return {
                ...state,
                isCreating: true,
            };
        },
        [COLLECTIONS.COLLECTION.CREATE.COMPLETED]: (state: IState, { error }: any): IState => {
            return {
                ...state,
                allCollectionsFetched: false,
                error,
                isCreating: false,
            };
        },
    },
    initialState,
);
